import { render, staticRenderFns } from "./ProjectsListItem.vue?vue&type=template&id=a4c9d6f0&scoped=true&"
import script from "./ProjectsListItem.vue?vue&type=script&lang=js&"
export * from "./ProjectsListItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsListItem.vue?vue&type=style&index=0&id=a4c9d6f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c9d6f0",
  null
  
)

export default component.exports